<template>
  <div>
    <section v-if="isFetchingEmployees">
      <spinner-loader :loading="isFetchingEmployees"/>
    </section>
    <section v-else-if="errored">
      <p class="centerscreen">An error occurred.</p>
    </section>
    <section v-else>
      <div>
        <!-- User Interface controls -->
        <section v-if="employees.length < 1">
          <p>There are currently no employees.</p>
        </section>
        <section v-else>
          <b-row class="search-header" align-h="center">
            <b-col md="6" class="my-1">
              <b-input-group>
                <b-form-input v-model="filter" :placeholder="$t('search')" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''"> &nbsp;X&nbsp; </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-table ref="EmployeeTable" class="employee-table" stacked="xs" hover :filter="filter" :emptyFilteredText="emptyFilteredText"
            :items="employees" :fields="fields" striped light @row-clicked="rowClicked">

            <template slot="cell(is_active)" slot-scope="row">{{row.value?'On':'Off'}}</template>

            <template slot="cell(active)" slot-scope="row" class="employee-table-row">
              {{((row.item.is_active) ? "ACTIVE" : "INACTIVE")}}
            </template>

            <template slot="cell(tools)" slot-scope="row">
              <div style="text-align:right;">
                <b-button size="md" variant="outline-secondary" @click.stop="handleUpdateEmployeeStatus(row.item.id, row.item.is_active)">
                  EDIT
                </b-button>
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-button size="md" variant="outline-secondary" :class="{btnActive:row.item.is_active}" @click.stop="handleUpdateEmployeeStatus(row.item.id, row.item.is_active)">
                  {{row.item.is_active?'ACTIVE':'INACTIVE'}}
                </b-button>

                <b-button size="md" variant="outline-secondary" @click="handleUpdateEmployeeStatus(row.item.id, row.item.is_active)">
                  RESET PIN
                </b-button>
                <b-button size="md" variant="outline-secondary" @click.stop="handleUpdateEmployeeStatus(row.item.id, row.item.is_active)">
                  EDIT
                </b-button>
              </b-card>
            </template>
          </b-table>
        </section>
        <employee-modal ref="employeeModal" class="contact-modal-btn-new employee-modal" @updateDone="getEmployees" />
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
import SpinnerLoader from "@/components/widgets/SpinnerLoader";
import axios from "axios";
import API from "../../../../api";
import EmployeeModal from "../../../../components/modals/EmployeeModal";

export default {
  name: "Employees",
  mounted() {
    this.getEmployees();
  },
  computed: {
    fields() {
      return [{
        key: "first_name",
        label: this.$t("first_name").toUpperCase(),
        sortable: true,
        thStyle: "border-top:none;"
      },
      {
        key: "last_name",
        label: this.$t("last_name").toUpperCase(),
        sortable: true,
        thStyle: "border-top:none;"
      },
      {
        key: "email",
        label: this.$t("email").toUpperCase(),
        sortable: true,
        thStyle: "border-top:none;"
      },
      {
        key: "role",
        label: this.$t("role").toUpperCase(),
        sortable: true,
        thStyle: "border-top:none;"
      },
      {
        key: "active",
        label: this.$t("active").toUpperCase(),
        sortable: false,
        thStyle: "border-top:none;"
      }
      ];
    }
  },
  data: () => ({
    title: "Employees",
    employees: [],
    isFetchingEmployees: false,
    errored: false,
    filter: null,
    emptyFilteredText: "No employees match your filter.",
    enableTableBorder: false
  }),
  components: {
    SpinnerLoader,
    EmployeeModal
  },
  methods: {
    rowClicked(_record, _index) {
      this.$refs.employeeModal.edit(_record);
    },
    getEmployees() {
      this.isFetchingEmployees = true;
      axios
        .get(`${API.BASE_URL}${API.EMPLOYEES}`, {
          headers: {
            Authorization: `Bearer ${API.TOKEN()}`,
            Accept: "application/json"
          }
        })
        .then(response => {
          if (response.status === 200) {
            var displayData = response.data;
            for (var i = 0; i < displayData.length; i++) {
              displayData[i]["_showDetails"] = false;
            }
            this.employees = response.data;
            this.isFetchingEmployees = false;
          }
        })
        .catch(error => {
          this.isFetchingEmployees = false;
          this.errored = true;
        });
    },
    updateEmployee(updatedEmployee) {
      const originalEmployee = this.employees.find(
        employee => employee.id === updatedEmployee.id
      );

      Vue.set(originalEmployee, "is_active", updatedEmployee.is_active);
    },
    toggleEmployeeStatus(is_active) {
      return is_active ? 0 : 1;
    },
    handleUpdateEmployeeStatus(id, is_active) {
      axios
        .put(
          `${API.BASE_URL}${API.EMPLOYEES}/${id}`, {
            is_active: this.toggleEmployeeStatus(is_active)
          }, {
            headers: {
              Authorization: `Bearer ${API.TOKEN()}`,
              Accept: "application/json"
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.updateEmployee(response.data.original);
          }
        })
        .catch(error => {
          this.errored = true;
        });
    },
    updateEmployeeRecord(_record) {
      axios
        .put(
          `${API.BASE_URL}${API.EMPLOYEES}/${id}`, _record, {
            headers: {
              Authorization: `Bearer ${API.TOKEN()}`,
              Accept: "application/json"
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.updateEmployee(response.data.original);
          }
        })
        .catch(error => {
          this.errored = true;
        });
    }
  }
};
</script>

<style>
  .toolCol {
    width: 80px;
  }

  th:focus {
    outline: none !important;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .employee-table {
    background: #EBEBEB !important;
    background-color: #EBEBEB !important;
  }

  .page-header {
    display: flex;
    width: 100%;
    align-content: space-between;
    text-align: left;
  }

  .page-title {
    width: 100%;
    font-size: 1.75rem;
    line-height: 54px;
    font-weight: 500;
    text-transform: uppercase;
    background: #ccc;
    left: 0px;
    height: 54px;
    padding-left: 10px;
    margin: 0px;
  }

  .search-header {
    background: #EBEBEB;
    padding: 10px 0px 10px 0px;
    position: relative;
    margin: 0px;
  }

  th {
    border-top: none;
    outline: none !important;
  }

  .btnActive {
    background: green;
    color: white;
  }

  .contact-modal-btn-new {
    position: absolute;
    right: 24px;
    top: 28px;
  }
</style>
